import ReactDOM from 'react-dom/client';

import AppWrapper from './AppWrapper';

import './index.css';
import './i18n/config';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<AppWrapper />);
